import React from 'react';
import { InjectedIntl, injectIntl, IntlProvider as OriginalIntlProvider } from 'react-intl';

const IntlContext = React.createContext<InjectedIntl>({} as InjectedIntl);

const InjectedProvider = injectIntl(({ intl, children }) => {
    return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
});

export function IntlProvider({
    children,
    ...props
}: OriginalIntlProvider.Props & { children: React.ReactNode }) {
    return (
        <OriginalIntlProvider {...props}>
            <InjectedProvider>{children}</InjectedProvider>
        </OriginalIntlProvider>
    );
}

export default IntlContext;
